module.exports = __webpack_public_path__ + "img/news_4.bab09b58.png";